<h1 mat-dialog-title>{{ title() }}</h1>
<div mat-dialog-content>
  <p>{{ message() }}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">
    {{ cancelText() }}
  </button>
  <button mat-button color="warn" (click)="onConfirm()">
    {{ confirmText() }}
  </button>
</div>